import * as React from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { useStaticQuery, graphql } from 'gatsby';
// import Flag from '../../images/flag.jpg';

const AcknowledgementStyled = styled.div`
	background-color: ${(props) => props.bgColor};
	//margin-bottom: 1rem;

	.acknowledgement {
		padding: 0.5em;
		margin-top: 3rem;
	}
	p {
		margin-top: 1rem;
	}

	.flag {
		display: flex;
		justify-content: left;
		align-items: center;
	}

	.acknowledgementText {
		text-align: left;
		margin-left: 1rem;
	}

	// mobile settings
	@media (max-width: 768px) {
		.flag {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.acknowledgementText {
			text-align: center;
			margin-left: 0;
		}
	}
`;

const DEFAULT_ACKNOWLEDGEMENT =
	'City Handyman acknowledges the Traditional Owners of the lands where we live, learn and work. We pay our respects to Elders past and present and celebrate the stories, culture and traditions of all First Nations people.';

export default function Acknowledgement() {
	const data = useStaticQuery(graphql`
		query {
			allStrapiFooter {
				nodes {
					acknowledgement
				}
			}
		}
	`);
	const acknowledgementText = data.allStrapiFooter.nodes[0]?.acknowledgement;

	return (
		<AcknowledgementStyled bgColor='var(--secondary_6)'>
			<div className='acknowledgement'>
				<Container>
					<Row>
						{/* Column 1 */}
						{/* <Col xs={12} md={2} lg={1} className='flag'>
							<img alt='Australian Aboriginal Flag' src={Flag} />{' '}
						</Col> */}

						{/* Column 2 */}

						<Col xs={12} md={10} lg={12}>
							<p className='acknowledgementText'>
								{acknowledgementText || DEFAULT_ACKNOWLEDGEMENT}
							</p>
						</Col>
					</Row>
				</Container>
			</div>
		</AcknowledgementStyled>
	);
}
